"use strict";

exports.__esModule = true;
var _DeviceDataItemStatsSelector = require("./DeviceDataItemStatsSelector");
Object.keys(_DeviceDataItemStatsSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDataItemStatsSelector[key]) return;
  exports[key] = _DeviceDataItemStatsSelector[key];
});